export default "__VITE_ASSET__B1bWXn0u__"